<template>
  <form>
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11" class="py-0">
        <v-row class="py-0">
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Payment Type</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select outlined flat dense background-color="white"></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Nomor # <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field outlined flat dense background-color="white"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="py-0">
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Branch</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select outlined flat dense background-color="white"></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Tanggal <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="dateStart"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateStart" @input="menuStart = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="py-0">
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Month</v-subheader>
              </v-col>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-select outlined flat dense background-color="white"></v-select>
              </v-col>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-text-field outlined flat dense background-color="white"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <v-row class="py-0">
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Jatuh Tempo <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="dateEnd"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateEnd" @input="menuEnd = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="py-0">
          <v-col cols="12" class="py-0">
            <v-tabs vertical background-color="light-blue accent-3" dark class="px-0">
              <v-tab>
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab>
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        background-color="white"
                        placeholder="Find/Choose Account"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">
                        Budget Detail <span class="red--text">*</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-data-table
                        :headers="headers"
                        :items="form.items"
                        disable-pagination
                        hide-default-footer
                      ></v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-title class="font-italic">Additional Info</v-card-title>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="pb-0">
                      <v-subheader>Hutang Beban <span class="red--text">*</span></v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="pb-0">
                      <v-select outlined flat dense background-color="white"></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>Catatan</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <v-textarea outlined flat rows="3"></v-textarea>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1" class="py-0 text-center">
        <v-row class="py-0">
          <v-col cols="12" class="mb-4 py-0">
            <v-btn color="primary">
              <v-icon large>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="mb-4 py-0">
            <v-btn color="amber darken-2">
              <v-icon large>
                mdi-printer
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";

export default {
  //   mixins: [validationMixin],

  //   validations: {
  //     form: {
  //       accountNo: { required },
  //       name: { required }
  //     }
  //   },

  data: () => ({
    defaultForm: {
      month: null,
      year: new Date().getFullYear().toString(),
      type: null,
      note: "",
      analysName: "",
      items: [
        { name: "produk 1", code: "RT125", budget: "10000" },
        { name: "produk 2", code: "RT126", budget: "10000" },
        { name: "produk 3", code: "RT127", budget: "10000" },
        { name: "produk 4", code: "RT128", budget: "10000" },
      ],
    },
    menuStart: false,
    menuEnd: false,
    dateEnd: new Date().toISOString().substr(0, 10),
    dateStart: new Date().toISOString().substr(0, 10),
    unlock: false,
    form: {},
    headers: [
      {
        text: "Expense/Income",
        value: "name",
        sortable: false,
        width: "70%",
        divider: true,
      },
      {
        text: "Code",
        value: "code",
        sortable: false,
        width: "15%",
        divider: true,
      },
      {
        text: "Budget",
        value: "budget",
        sortable: false,
        divider: true,
        width: "15%",
      },
    ],
  }),

  computed: {},

  watch: {
    form: {
      handler() {
        this.unlock = true;
      },
    },
  },

  methods: {
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        for (let key in Object.keys(this.$v.form)) {
          const input = Object.keys(this.$v.form)[key];
          if (input.includes("$")) return false;
          if (this.$v.form[input].$error) {
            this.$refs[input].focus();
            break;
          }
        }
      } else {
        console.log(this.form);
      }
    },
    clear() {
      this.$v.form.$reset();
      this.form = Object.assign({}, this.defaultForm);
    },
  },

  mounted() {
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
